import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  showSpinner = false;
  private spinnerTracker = 0;

  constructor(private service: NgxSpinnerService) { }

  open() {
    this.spinnerTracker++;
    setTimeout(() => {
      this.showSpinner = true;
      this.service.show();
    });
  }

  close() {
    if (this.spinnerTracker > 0)
      this.spinnerTracker--;
    if (this.spinnerTracker === 0)
      setTimeout(() => {
        this.showSpinner = false;
        this.service.hide();
      });
  }

  reset() {
    this.spinnerTracker = 0;
    this.showSpinner = false;
    this.service.hide();
  }
}
